import React from "react";
import { withRouter } from 'react-router-dom'
import { Tabs } from 'antd';
import axios from "axios";
import './style.css';
import BasicSettings from './BasicSettings';
import { withTranslation } from 'react-i18next';
import PasswordSettings from "./PasswordSettings";


const { TabPane } = Tabs;

class ProfileView extends React.Component {
    state = {
        user: []
    };

    componentDidMount() {
        let token = localStorage.getItem('token');
        axios.defaults.xsrfCookieName = 'csrftoken'
        axios.defaults.xsrfHeaderName = "X_CSRFTOKEN"
        axios.defaults.headers = {
            "Content-Type": "application/json",
            "Accept-Language": localStorage.getItem('language'),
            Authorization: `Token ${token}`,
        };

        this.fetch();
    }

    fetch = e => {
        let requestList = [];
        requestList.push(axios.get(process.env.REACT_APP_AXIOS_URL + "/api/profile/"));

        axios.all(requestList).then(axios.spread((...responses) => {
            const responseUsers = responses[0];

            this.setState({
                user: responseUsers.data,
                loading: false
            });
        })).catch(errors => {
            console.log(errors);
        });
    }

    render() {
        const { t } = this.props;

        return (
            <div>
                <Tabs tabPosition='left' size='large'>
                    <TabPane tab={t('profile.basic_settings_name', "Basic settings")} key="1">
                        <p className='pStyle'>{t('profile.basic_settings_name', "Basic settings")}</p>
                        <BasicSettings
                            data={this.state.user}
                        />
                    </TabPane>
                    <TabPane tab={t('profile.security_settings_name', "Security settings")} key="2">
                        <p className='pStyle'>{t('profile.security_settings_name', "Security settings")}</p>
                        <PasswordSettings />
                    </TabPane>
                    {/* <TabPane tab={t('profile.security_settings_name', "Security settings")} key="3">
                        <p className='pStyle'>{t('profile.security_settings_name', "Security settings")}</p>
                    </TabPane>
                    <TabPane tab={t('profile.email_settings_name', "Email settings")} key="4">
                        <p className='pStyle'>{t('profile.email_settings_name', "Email settings")}</p>
                    </TabPane> */}
                </Tabs>
            </div>
        )
    }
}

export default withRouter(withTranslation()(ProfileView));


// WEBPACK FOOTER //
// ./src/containers/Profile/ProfileView.js